module.exports = __webpack_public_path__ + "static/img/dadiType1.8b4a2b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/dadiType1.jpg
// module id = JjoZ
// module chunks = 4